import { DefaultEffects, IButtonStyles, IDialogStyleProps, IDialogStyles, IModalStyleProps, IModalStyles, IProgressIndicatorStyleProps, IProgressIndicatorStyles, ISpinnerStyleProps, ISpinnerStyles, IStyleFunctionOrObject, mergeStyles, MotionAnimations, MotionDurations } from "@fluentui/react";
import { max } from "lodash-es";

//#region Spinner

export const lgSpinnerStyles: IStyleFunctionOrObject<ISpinnerStyleProps, ISpinnerStyles> = {
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        animation: MotionAnimations.fadeIn,
        animationDuration: MotionDurations.duration1,
    },
    circle: {
        width: '70px',
        height: '70px'
    },
    label: {
        fontSize: '22pt',
        marginTop: '10px',
        fontFamily: 'Nunito',
        fontWeight: 300,
        color: '#2A7DE1'
    }
};

export const mdSpinnerStyles: IStyleFunctionOrObject<ISpinnerStyleProps, ISpinnerStyles> = {
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        animation: MotionAnimations.fadeIn,
        animationDuration: MotionDurations.duration1,
    },
    circle: {
        width: '60px',
        height: '60px'
    },
    label: {
        fontSize: '20pt',
        marginTop: '10px',
        fontFamily: 'Nunito',
        fontWeight: 300,
        color: '#2A7DE1'
    }
};

export const smSpinnerStyles: IStyleFunctionOrObject<ISpinnerStyleProps, ISpinnerStyles> = {
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        animation: MotionAnimations.fadeIn,
        animationDuration: MotionDurations.duration1,
    },
    circle: {
        width: '50px',
        height: '50px'
    },
    label: {
        fontSize: '18pt',
        marginTop: '10px',
        fontFamily: 'Nunito',
        fontWeight: 300,
        color: '#2A7DE1'
    }
};

//#endregion Spinner

//#region Register Header

export const headerContainerStyles = mergeStyles([{
    width: "100%",
    height: "20dvh",
    position: "relative"
}]);

export const closeButtonStyle: IButtonStyles = {
    root: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        backgroundColor: '#FFFFFF',
        border: 'none',
        color: '#2A7DE1'
    },
    icon: {
        fontSize: '1.5rem'
    },
    rootDisabled: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        backgroundColor: '#FFFFFF',
        border: 'none',
        color: '#2A7DE1'
    }
};

//#endregion Register Header

//#region Register Content

export const contentStyles = mergeStyles([{
    width: '100%',
    height: '70dvh',
    maxHeight: '70dvh',
    overflowY: 'auto',
}]);

//#endregion Register Content

//#region Footer

export const footerContainerStyles = mergeStyles([{
    width: '100%',
    height: '10dvh',
    position: 'relative'
}]);

export const lgDefaultButtonStyle: IButtonStyles = {
    root: {
        width: '160px',
        height: '40px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const mdDefaultButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const smDefaultButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const lgDefaultIconButtonStyle: IButtonStyles = {
    root: {
        width: '110px',
        height: '40px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    }
};

export const mdDefaultIconButtonStyle: IButtonStyles = {
    root: {
        width: '100px',
        height: '35px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    }
};

export const smDefaultIconButtonStyle: IButtonStyles = {
    root: {
        width: '90px',
        height: '35px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    }
};

export const lgPrimaryButtonStyle: IButtonStyles = {
    root: {
        width: '160px',
        height: '40px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const mdPrimaryButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const smPrimaryButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const lgPrimaryIconButtonStyle: IButtonStyles = {
    root: {
        width: '110px',
        height: '40px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    }
};

export const mdPrimaryIconButtonStyle: IButtonStyles = {
    root: {
        width: '100px',
        height: '35px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    }
};

export const smPrimaryIconButtonStyle: IButtonStyles = {
    root: {
        width: '90px',
        height: '35px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    }
};

export const helpButtonStyle: IButtonStyles = {
    label: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.9rem, 2.3vw, 1.2rem)',
    },
    icon : {
        fontSize: 'clamp(0.9rem, 2.3vw, 1.2rem)',
    }
};

export const xxlHelpButtonStyle: IButtonStyles = {
    label: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.9rem, 2.2vw, 1.1rem)',
    },
    icon : {
        fontSize: 'clamp(0.9rem, 2.2vw, 1.1rem)',
    }
};

export const xlHelpButtonStyle: IButtonStyles = {
    label: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
    },
    icon : {
        fontSize: 'clamp(0.9rem, 2.2vw, 1.1rem)',
    }
};

export const lgHelpButtonStyle: IButtonStyles = {
    label: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
    },
    icon : {
        fontSize: 'clamp(0.9rem, 2.2vw, 1.1rem)',
    }
};

export const mdHelpButtonStyle: IButtonStyles = {
    label: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2vw, 1rem)',
    },
    icon : {
        fontSize: 'clamp(0.8rem, 2vw, 1rem)',
    }
};

export const smHelpButtonStyle: IButtonStyles = {
    label: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.7rem, 2vw, 1rem)',
    },
    icon : {
        fontSize: 'clamp(0.7rem, 2vw, 1rem)',
    }
};

//REVERSED

export const lgReversedDefaultButtonStyle: IButtonStyles = {
    root: {
        width: '160px',
        height: '40px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    },
    flexContainer: {
        flexDirection: 'row-reverse'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const mdReversedDefaultButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    },
    flexContainer: {
        flexDirection: 'row-reverse'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const smReversedDefaultButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        color: '#2A7DE1',
        boxShadow: DefaultEffects.elevation8
    },
    flexContainer: {
        flexDirection: 'row-reverse'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const lgReversedPrimaryButtonStyle: IButtonStyles = {
    root: {
        width: '160px',
        height: '40px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    },
    flexContainer: {
        flexDirection: 'row-reverse'
    },
    label: {
        fontFamily: 'Nunito',
        fontSize: '12pt'
    }
};

export const mdReversedPrimaryButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    },
    flexContainer: {
        flexDirection: 'row-reverse'
    }
};

export const smReversedPrimaryButtonStyle: IButtonStyles = {
    root: {
        width: '150px',
        height: '35px',
        backgroundColor: '#2A7DE1',
        borderRadius: '20px',
        color: '#FFFFFF',
        boxShadow: DefaultEffects.elevation8
    },
    flexContainer: {
        flexDirection: 'row-reverse'
    }
};

//#endregion Footer

//#region Progress bar

export const progressBarStyles: IStyleFunctionOrObject<IProgressIndicatorStyleProps, IProgressIndicatorStyles> = {
    root: {
        width: '100%',
        margin: '0 auto',
        paddingTop: '10px'
    },
    progressTrack: {
        borderRadius: '10px',
        position: 'absolute',
        height: '8px',
        top: '50%',
        transform: 'translateY(-50%)',
    },
    progressBar: {
        borderRadius: '10px',
        backgroundColor: '#2A7DE1',
        position: 'absolute',
        height: '8px',
        top: '50%',
        transform: 'translateY(-50%)',
        padding: '0'
    },
    itemDescription: {
        fontFamily: 'Nunito'
    },
    itemName: {
        fontFamily: 'Nunito'
    }
};

//#endregion Progress bar

//#region Register Logo

export const logoStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxHeight: 'clamp(11dvh, 12dvh, 14dvh)',
    margin: '0 auto',
}]);

export const xxlLogoStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxHeight: 'clamp(9dvh, 10dvh, 12dvh)',
    margin: '0 auto',
}]);

export const xlLogoStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxHeight: 'clamp(7dvh, 9dvh, 10dvh)',
    margin: '0 auto',
}]);

export const lgLogoStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxHeight: 'clamp(6dvh, 8dvh, 10dvh)',
    margin: '0 auto',
}]);

export const mdLogoStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxHeight: 'clamp(5dvh, 6dvh, 8dvh)',
    margin: '0 auto',
}]);

export const smLogoStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxHeight: 'clamp(3dvh, 5dvh, 8dvh)',
    margin: '0 auto',
}]);

//#endregion Register Logo

//#region Register Confirm Dialog

export const dialogTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#2A7DE1'
}]);

export const xxlDialogTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.2rem, 3vw, 1.4rem)',
    fontWeight: 600,
    color: '#2A7DE1'
}]);

export const xlDialogTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.1rem, 2.8vw, 1.3rem)',
    fontWeight: 600,
    color: '#2A7DE1'
}]);

export const lgDialogTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.6vw, 1.2rem)',
    fontWeight: 600,
    color: '#2A7DE1'
}]);

export const mdDialogTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.95rem, 2.4vw, 1.1rem)',
    fontWeight: 600,
    color: '#2A7DE1'
}]);

export const smDialogTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.2vw, 1rem)',
    fontWeight: 600,
    color: '#2A7DE1'
}]);

export const dialogDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const xxlDialogDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const xlDialogDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const lgDialogDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const mdDialogDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.5vw, 0.8rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const smDialogDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.2vw, 1rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const dialogPrimaryButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 300,
        color: '#FFFFFF',
    }
};

export const xxlDialogPrimaryButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
        fontWeight: 300,
        color: '#FFFFFF',
    }
};

export const xlDialogPrimaryButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)',
        fontWeight: 300,
        color: '#FFFFFF',
    }
};

export const lgDialogPrimaryButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
        fontWeight: 300,
        color: '#FFFFFF',
    }
};

export const mdDialogPrimaryButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
        fontWeight: 300,
        color: '#FFFFFF',
    }
};

export const smDialogPrimaryButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: '#2A7DE1',
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
        fontWeight: 300,
        color: '#FFFFFF',
    }
};

export const dialogDefaultButtonStyles: IButtonStyles = {
    root: {
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: '1rem',
        fontWeight: 300,
        color: '#000000'
    }
};

export const xxlDialogDefaultButtonStyles: IButtonStyles = {
    root: {
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
        fontWeight: 300,
        color: '#000000'
    }
};

export const xlDialogDefaultButtonStyles: IButtonStyles = {
    root: {
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)',
        fontWeight: 300,
        color: '#000000'
    }
};

export const lgDialogDefaultButtonStyles: IButtonStyles = {
    root: {
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
        fontWeight: 300,
        color: '#000000'
    }
};

export const mdDialogDefaultButtonStyles: IButtonStyles = {
    root: {
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
        fontWeight: 300,
        color: '#000000'
    }
};

export const smDialogDefaultButtonStyles: IButtonStyles = {
    root: {
        borderRadius: '5px'
    },
    textContainer: {
        fontFamily: 'Nunito',
        fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
        fontWeight: 300,
        color: '#000000'
    }
};

//#endregion Register Confirm Dialog

//#region Register Chat 

export const rightContainerStyles = mergeStyles([{
    height: '100%',
    width: '30%',
    boxShadow: DefaultEffects.elevation16,
    backgroundColor: '#F8FAFF',
    borderRadius: '10px'
}]);

export const chatContainerStyles = mergeStyles([{
    margin: "25px",
    height: "100%",
    gap: "20px"
}]);

export const chatInnerContainerStyles = mergeStyles([{
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    height: '100%',
    maxHeight: 'calc(100dvh - 80px)',
    width: "100%",
    maxWidth: "100%",
    margin: '0 auto',
    fontFamily: "Nunito",
}]);

//#endregion Register Chat